import Cookies from 'js-cookie'

import { IS_LOGGED_IN_COOKIE_NAME } from '@/lib/constants'
import { toggleDarkMode } from '@/lib/darkmode'
import { isRoutePublic } from '@/lib/routes'
import { UserPrefs } from '@/lib/prefs'

export default ({ app }) => {
  app.router.beforeEach(async (to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const authRequired = !isRoutePublic(to)
    const firstPageLoad = !from.name
    const isLoggedInCookie = Cookies.get(IS_LOGGED_IN_COOKIE_NAME)

    if (firstPageLoad) {
      app.store.dispatch('loadFeatureFlags')
    }

    if ((authRequired || isLoggedInCookie) && !app.store.state.profile) {
      await app.store.dispatch('getProfile')

      // Initialize dark mode
      let prefs = new UserPrefs(app.store)
      toggleDarkMode(prefs.darkMode)
    }

    if (firstPageLoad) {
      app.store.dispatch('finishedInitialLoad')
    }

    const isLoggedIn = app.store.getters.isLoggedIn

    if (isLoggedIn && to.path == '/') {
      next({ path: '/dashboard', query: to.query })
    } else if (authRequired && !isLoggedIn) {
      app.store.dispatch('logout')
      next({ path: '/login', query: { next: to.path } })
    } else {
      // Make sure that the next function is called exactly once in any given pass through the navigation guard.
      // https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
      next()
    }
  })
}
